import WorkService from '@/service/work';
import localforage from 'localforage';
import { observable, action, runInAction } from 'mobx';

const moOutput = observable({
  outputTabActive: '营业收入',
  outputTimeActive: '2018',
  outputList: <any>{},
});


// 修改tab
const changeTab = action(async (val: string) => {
  runInAction(() => {
    moOutput.outputTabActive = val;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.outputtab = val;
  localforage.setItem('humans', humanData);
});

// 修改默认tab
const changeOutTab = action(async (val: string) => {
  runInAction(() => {
    moOutput.outputTabActive = val;
  });
});

// 修改时间tab
const changeTimeTab = action(async (val: string) => {
  runInAction(() => {
    moOutput.outputTimeActive = val;
  });
  const list = await WorkService.outputTop10({
    year: val,
  });
  runInAction(() => {
    moOutput.outputList = list;
  });
  const humanData: any = await localforage.getItem('humans') || {};
  humanData.outputtime = val;
  localforage.setItem('humans', humanData);
});

// 修改默认时间

const changeDefaltOuttime = action(async (val: string) => {
  runInAction(() => {
    moOutput.outputTimeActive = val;
  });
});

// 获取数据

const getOutputTop10 = action((list: any) => {
  runInAction(() => {
    moOutput.outputList = list;
  });
});

export default moOutput;
export { changeTab, changeTimeTab, changeDefaltOuttime, getOutputTop10, changeOutTab };
